import { useEffect, useState } from "react";
import Loader from "../../components/Loader";

export default function SearchSkillsResults({
  results,
  isLoading,
  handleSelectedSkills,
  selectedSkills,
  handleResults,
}) {
  const [resultsValues, setResultsValues] = useState([]);

  useEffect(() => {
    if (isLoading) {
      document
        .querySelector(".search-skills__label--wrapper")
        .classList.add("disabled");
    } else {
      document
        .querySelector(".search-skills__label--wrapper")
        .classList.remove("disabled");
    }
  }, [isLoading]);

  const handleResultsValues = (e) => {
    const { value, checked } = e.target;

    setResultsValues((prevState) => {
      if (checked) {
        return [...new Set([...prevState, value])];
      } else {
        return prevState.filter((item) => item !== value);
      }
    });
  };

  useEffect(() => {
    handleSelectedSkills(resultsValues);
    handleResults(resultsValues);
  }, [resultsValues]);

  return (
    <div className="skill-results-parent">
      <div className="skills-results">
        {isLoading ? (
          <Loader />
        ) : results ? (
          results.map((curr, index) => {
            const categoryName = curr.name
              .replace(/\s+/g, "_")
              .replace("-", "_")
              .toLowerCase()
              .slice(0, -1);
            return (
              <div className="skills-results-wrapper" key={index}>
                <div className="skills-results-wrapper__single">
                  <div className="form-group">
                    <span>{curr.name}</span>
                    <div className="label-results-wrapper">
                      {curr.skills.map((skill) => (
                        <label key={skill.id}>
                          <input
                            type="checkbox"
                            value={skill.id}
                            onChange={handleResultsValues}
                            name="skills"
                            checked={selectedSkills.includes(String(skill.id))}
                          />
                          <span>{skill.name}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>No skills selected</p>
        )}
      </div>
    </div>
  );
}
